
import React, { useEffect, useState } from "react";
import { allClients } from "../../api";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../context";
import { radioType } from "../../interfaces";
import Header from "../../Components/Header/Header";
import BorderColorRoundedIcon from "@mui/icons-material/BorderColorRounded";
import chunk from "chunk";
import Pagination from "react-js-pagination";
import "./billingSheet.css";
import PinCodeWindow from "./PinCodeWindow";
import PinForEdit from "./PinForEdit";
import Loading from "../../Components/Loading/Loading";
import Cancelation from "../AllClients/Cancelation";
import ReasonForCancel from "../AllClients/ReasonForCancel";

function ClientsBilling() {

    const {
        setOpenPinCode,
        setOpenPinForEdit,
        setLoading,
        findRole,
        concretClient,
        setConcretClient,
        clients, setClients
    } = useGlobalContext()

    const [searchBarInpValue, setSearchBarInpValue] = useState<string>("");
    const [searchBtn, setSearchBtn] = useState<boolean>(false);
    const [showClients, setShowClients] = useState<Array<any>>([]);
    const [showChunk, setShowChunk] = useState<Array<any>>([]);
    const [activePage, setActivePage] = useState<number>(1);
    const [clientId, setClientId] = useState<number | undefined>();
    const [openCansel, setOpenCansel] = useState<boolean>(false);
    const [openReason, setOpenReason] = useState<boolean>(false);
    const [reasonsType, setReasonsType] = useState<radioType[]>([
        {
            id: 1,
            title: "Family Emergency",
            active: true,
        },
        {
            id: 2,
            title: "Out of the Country",
            active: false,
        },
        {
            id: 3,
            title: "Out of Business",
            active: false,
        },
        {
            id: 4,
            title: "No Funds",
            active: false,
        },
        {
            id: 5,
            title: "Content",
            active: true,
        },
        {
            id: 6,
            title: "Our Mistake (Wrong Info)",
            active: false,
        },
        {
            id: 7,
            title: "Our Mistake (Grammar Issues)",
            active: false,
        },
        {
            id: 8,
            title: "Business change",
            active: false,
        },
        {
            id: 9,
            title: "Brokerage Has Our Service",
            active: true,
        },
        {
            id: 10,
            title: "Requests Being Late",
            active: false,
        },
        {
            id: 11,
            title: "No Answer to our Calls/Emails",
            active: false,
        },
        {
            id: 12,
            title: "Ad Campaign",
            active: false,
        },
        {
            id: 13,
            title: "Charges disputed",
            active: false,
        },
        {
            id: 14,
            title: 'Dissatisfaction with the quality of service',
            active: false
        },
        {
            id: 15,
            title: 'No Payment or Response (Trial)',
            active: false
        },
        {
            id: 16,
            title: 'No Payment or Response (Not Trial)',
            active: false
        },
        {
            id: 17,
            title: 'Disputed',
            active: false
        },
        {
            id: 18,
            title: 'Issues with AM',
            active: false
        },
        {
            id: 19,
            title: 'No Results',
            active: false
        },
        {
            id: 21,
            title: 'Doesn\'t need our services',
            active: false
        },
        {
            id: 20,
            title: "Other",
            active: false,
        }
    ]);
    const [otherType, setOtherType] = useState('');

    const navigate = useNavigate();

    const gettingClients = async () => {
        setLoading(true);
        try {
            const getData = await allClients();
            setClients(getData.data.reverse());
        }
        catch(e) {
            console.log(e);
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (clients.length ===0) gettingClients().then(r => r);
    }, []);

    useEffect(() => {
        setShowClients(clients);
    }, [clients])

    useEffect(() => {
        const chunkData = chunk(showClients, 20);
        setShowChunk(chunkData[activePage - 1]);
    }, [activePage, showClients])

    useEffect(() => {
        if (!searchBarInpValue) {
            setShowClients(clients);
            setActivePage(1);
        }
        else {
            setSearchBtn(true);
        }
    }, [searchBarInpValue])

    const handleCombinedSearch = (): void => {
        setShowClients(clients);
        setActivePage(1);
        if (searchBarInpValue) {
            setShowClients(showClients => showClients.filter(client => {
                const fullName = client.firstName.replaceAll(" ", "") + client.lastName.replaceAll(" ", "");
                const company = client.businessData.companyName?.replaceAll(" ", "");
                const phoneNumber = client.phoneNumbers[0]?.value.replaceAll(" ", "");
                const email = client.emails[0]?.replaceAll(" ", "");
                if (fullName.toLowerCase().includes(searchBarInpValue.replaceAll(" ", "").toLowerCase())) {
                    return fullName.toLowerCase().includes(searchBarInpValue.replaceAll(" ", "").toLowerCase());
                }
                else if (company?.toLowerCase().includes(searchBarInpValue.replaceAll(" ", "").toLowerCase())) {
                    return company?.toLowerCase().includes(searchBarInpValue.replaceAll(" ", "").toLowerCase());
                }
                else if (phoneNumber?.includes(searchBarInpValue.replaceAll(" ", "").toLowerCase())) {
                    return phoneNumber.includes(searchBarInpValue.replaceAll(" ", "").toLowerCase());
                }
                else if (email?.includes(searchBarInpValue.replaceAll(" ", "").toLowerCase())) {
                    return email.includes(searchBarInpValue.replaceAll(" ", "").toLowerCase());
                }
                else {
                    return false;
                }
            }))
        }
    }

    document.body.onkeydown = (e) => {
        if (e.key === "Enter" && searchBarInpValue) {
            handleCombinedSearch();
        }
    }

    const handlePageChange = (pageNumber: number) => {
        setActivePage(pageNumber);
    }

    const goToClientInfo = (id: number) => {
        setClientId(id);
        setOpenPinCode(true);
    }

    const goToActivity = () => {
        navigate("/billing-activity");
    }

    const goToStatistics = () => {
        navigate("/billing-statistics");
    }

    const goToEdit = (id: number) => {
        setClientId(id);
        setOpenPinForEdit(true);
    }

    return (
        <div className = "ClientsBilling">
            <Header />
            <div className = "allClients-container">
                <div className = "allClients-header billing-allClients-header" style = {{ marginBottom: "30px" }}>
                    <div className = "allClients-header-heading">
                        <h2>MBS Clients</h2>
                    </div>
                    <div className = "allClients-header-btns billing-allClients-header-btns">
                        <button
                            onClick = { goToStatistics }
                        >
                            Statistics
                        </button>
                        <button
                            onClick = { goToActivity }
                        >
                            Activity
                        </button>
                    </div>
                </div>
                <div className = "allClients-searchBar">
                    <div className = "allClients-searchBar-inp">
                        <span>Search by Client Name</span>
                        <input
                            type = "text"
                            value = { searchBarInpValue }
                            onChange = { (e) =>
                                setSearchBarInpValue(e.target.value)
                            }
                        />
                    </div>
                    <div className="allClients-searchBar-btn">
                        <button
                            style = {{ cursor: searchBtn ? "pointer" : "not-allowed" }}
                            onClick = { handleCombinedSearch }
                            disabled = { !searchBtn }
                        >
                            Search
                        </button>
                    </div>
                </div>
                <div className = "allClients-container-block">
                    <table className = "billing-allClients-table">
                        <thead>
                            <tr>
                                {
                                    ( findRole("PX") === "ADMIN" || findRole("PX") === "MODERATOR" ) &&
                                        <th>Status</th>
                                }
                                <th>Full Name</th>
                                <th className = "billing-email-date">Email</th>
                                <th className = "billing-phoneNumber-data">Phone Number</th>
                                <th className = "billing-creation-date">Creation Date</th>
                                <th className="all-clients-creation-date">Reason</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                showChunk?.map((client: any) =>
                                    <tr key = { client.id }>
                                        {
                                            ( findRole("PX") === "ADMIN" || findRole("PX") === "MODERATOR" ) &&
                                            <td>
                                                {
                                                    <button
                                                        className = "allClientStatus"
                                                        onClick = {() => {
                                                            setConcretClient(client);
                                                            if (!client.active) setOpenReason(true);
                                                            else setOpenCansel(true);
                                                        }}
                                                    >
                                                        <input
                                                            type = "checkbox"
                                                            className = "checkbox"
                                                            defaultChecked = { !client.active }
                                                        />
                                                        <label
                                                            htmlFor = {`toggle-${ client.id }`}
                                                            className = "activateBtnLabel"
                                                        >
                                                            <span className = "activateBtn"></span>
                                                        </label>
                                                    </button>
                                                }
                                            </td>
                                        }
                                        <td
                                            className = "clientFullNameData"
                                            style = {{
                                                cursor: "pointer"
                                            }}
                                            onClick = { () => goToClientInfo(client.id) }
                                        >
                                            { client.clientNameMain ? (client.firstName + " " + client.lastName) : client.businessData.companyName }
                                        </td>
                                        <td className = "billing-email-date">{ client.emails[0] }</td>
                                        <td className = "billing-phoneNumber-data">{ client.phoneNumbers[0]?.value }</td>
                                        <td className = "billing-creation-date">{ new Date(client.creationDate).toLocaleDateString() }</td>
                                        <td className="all-clients-creation-date">
                                            { client.cancellationReason ? client.cancellationReason === 'Other' ? client.cancellationOtherText : client.cancellationReason : '-' }
                                        </td>
                                        <td>
                                            <BorderColorRoundedIcon
                                                className = "edit-billing-client-icon"
                                                onClick = { () => goToEdit(client.id) }
                                            />
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                    <div className = "allClients-pages">
                        <Pagination
                            activePage = { activePage }
                            activeLinkClass = "activeLogPageNumber"
                            linkClass = "logPageNumber"
                            itemsCountPerPage = { 20 }
                            totalItemsCount = { showClients.length }
                            pageRangeDisplayed = { 5 }
                            hideFirstLastPages = { true }
                            onChange = { handlePageChange }
                        />
                    </div>
                </div>
            </div>
            <PinCodeWindow
                clientId = { clientId }
            />
            <PinForEdit
                clientId = { clientId }
            />
            <Loading/>
            {
                concretClient &&
                    <Cancelation
                        openCancel = { openCansel }
                        setOpenCancel = { setOpenCansel }
                        concretClient = { concretClient }
                        setConcretClient = { setConcretClient }
                        reasonsType = { reasonsType }
                        gettingClients = { gettingClients }
                        setActivePage = { setActivePage }
                        otherType = { otherType }
                        setOtherType = { setOtherType }
                    />
            }
            <ReasonForCancel
                openReason = { openReason }
                setOpenReason = { setOpenReason }
                reasonsType = { reasonsType }
                setReasonsType = { setReasonsType }
                setOpenCancel = { setOpenCansel }
                otherType = { otherType }
                setOtherType = { setOtherType }
            />
        </div>
    )
}

export default ClientsBilling
